import React, { useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";

import { formatUserName } from "@examspark/common";
import { useQueryGetWorkspaceUser } from "@examspark/common-app";
import { RouterLink, Tabs, VSpace } from "@examspark/common-ui";

import Breadcrumbs from "../../components/common/Breadcrumbs";
import PageHead from "../../components/common/PageHead";
import PageTitle from "../../components/common/PageTitle";

const PageSections = styled(VSpace)`
  gap: 3rem;
`;

const Empty = styled.div`
  padding: 5rem;
  color: #777;
  font-size: 2rem;
  text-align: center;
  font-weight: 300;
  border: dashed 2px #ccc;
`;

const UserRoute = () => {
  const [tab] = useState("classrooms");
  const params = useParams<{
    userId: string;
    workspaceId: string;
  }>();
  const { data } = useQueryGetWorkspaceUser(params.workspaceId, params.userId);

  return (
    <PageSections>
      <PageHead>
        <Breadcrumbs
          items={[
            ...Breadcrumbs.Dashboard(),
            <RouterLink
              key="dashboard"
              to="/workspace"
              // tabIndex={props?.disableTab && -1}
            >
              Workspace Settings
            </RouterLink>,
            <RouterLink
              key="people"
              to="/workspace/people"
              // tabIndex={props?.disableTab && -1}
            >
              People
            </RouterLink>,
          ]}
        />
        <PageTitle>{formatUserName(data?.user) ?? "Loading..."}</PageTitle>
      </PageHead>
      <Tabs
        value={tab || "classrooms"}
        onChange={(value) => {
          // navigate(value === "overview" ? "/workspace" : `/workspace/${value}`);
        }}
      >
        <Tabs.TabItem value="classrooms">Classrooms</Tabs.TabItem>
      </Tabs>
      <Empty>User Activity View Coming Soon</Empty>
    </PageSections>
  );
};

export default UserRoute;
